import { AngularFireAnalytics } from '@angular/fire/analytics';
import { environment } from './../../../environments/environment';
import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {

  @Input() isStartPage: boolean = false;
  @Input() title: string;
  @Input() iconTitle: string;
  @Input() endButtonDisable: boolean;
  @Input() endButtonHidden: boolean;
  @Input() endButtonImg: string = '';
  @Input() endButtonIcon: null | string = '';
  @Input() destinationPage: string = 'support';

  iconsrute = '/assets/imgs/icons/'

  constructor(
    private firebaseAnalytics: AngularFireAnalytics
  ) { }

  ngOnInit() { }

  onClick(event: any) {
    this.firebaseAnalytics.logEvent('showAppTutorials');
    window.open(environment.tutorialsLink, 'blank');
  }
}
